module.exports = new __parcel__URL__("geyser.32da7bc5.jpg").toString();